import React from 'react';

export const TriangleIcon = () => (
  <svg width="10" height="5" viewBox="0 0 10 5" fill="none">
    <path d="M0 0L5 5L10 0H0Z" fill="#3D3D3D" fillOpacity="0.6" />
  </svg>
);
